/**
 * Thin activator for the patriotic flag background.
 *
 * The actual <video> + wash + tuner now live ONCE at the app root in
 * <GlobalFlagBackgroundProvider> (see GlobalFlagBackground.tsx) so the clip is
 * downloaded/decoded a single time and never reloads or freezes when switching
 * between Search and Scenarios. This component just registers, for the lifetime
 * of the page that renders it, that the global flag should be visible.
 *
 * Kept as a drop-in: pages still `import FlagBackground, { tunerTap }` and
 * render <FlagBackground dark={...} /> exactly as before.
 */
import { useFlagBackgroundActive } from "@/components/GlobalFlagBackground";

export { tunerTap } from "@/components/GlobalFlagBackground";

// `dark` is accepted for backward compatibility; the global layer reads theme
// from ThemeContext directly, so the prop is no longer needed here.
export default function FlagBackground(_props: { dark?: boolean }) {
  useFlagBackgroundActive();
  return null;
}
